import { AfterViewInit, Component, EventEmitter, Injectable, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import {IsJson, PrettifyJson, TryParseJsonWithErrorDetails} from '../../../shared/utils/json.utils';

export type CodeEditorMode = 'json' | 'text';
export type CodeEditorEvent = 'syntaxError';

export interface EditorEvent { type: CodeEditorEvent; data: string; }

@Component({
  selector: 'app-configuration-editor',
  templateUrl: '../templates/configurationEditor.component.html',
  encapsulation: ViewEncapsulation.None,
})
@Injectable()
export class ConfigurationEditorComponent implements OnInit, AfterViewInit {
  @ViewChild('editor') editor;

  @Input() text: string;
  @Input() style: string;

  @Output() editorEvent = new EventEmitter<EditorEvent>();
  @Output() textChange = new EventEmitter<string>();
  @Output() modeChange = new EventEmitter<CodeEditorMode>();

  editorText: string;
  editorMode: CodeEditorMode;

  ngOnInit() {
    this.checkEditorMode(this.text);
    this.setTextEditor(this.text);
  }

  ngAfterViewInit(): void {
    this.editor.getEditor().commands.addCommand({
      name: 'showSearchBox',
      bindKey: 'Ctrl-f',
      exec: function (editor) {
        editor.execCommand('find');
      }
    });

    this.PrettifyIfEditorInJsonMode();
  }

  onEditorTextChanged(newText: string) {
    this.checkEditorMode(newText);
    this.setTextEditor(newText);
  }

  private setEditorMode(newEditorMode: CodeEditorMode) {
    if (this.editorMode === newEditorMode) { return; }
    this.editorMode = newEditorMode;
    this.modeChange.emit(this.editorMode);
  }

  private setTextEditor(text: string) {
    this.editorText = text;

    if (this.editorMode === 'json') {
      const [ isValidJson, err ] = TryParseJsonWithErrorDetails(this.editorText);
      if (!isValidJson) { this.editorEvent.emit({ type: 'syntaxError', data: err }); }
    }

    this.textChange.emit(text);
  }

  private checkEditorMode(text: string) {
    const newEditorMode = IsJson(text) ? 'json' : 'text';
    this.setEditorMode(newEditorMode);
  }

  private PrettifyIfEditorInJsonMode() {
    this.setTextEditor(this.editorMode === 'json' ? PrettifyJson(this.editorText) : this.editorText);
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/components/scripts/configurationEditor.component.ts